import { useState } from "react";
import { useEffect } from "react";

import '../css/instagram.css';


function InstagramTile({ post, index }) {
  
  const [loaded, setLoaded] = useState(false);

  return (
    <a
      className="ig-tile"
      href={post.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ animationDelay: `${index * 60}ms` }}
      aria-label={`Post by ${post.username}`}
    >
      <div className="ig-tile__img-wrap">
        {!loaded && <div className="ig-tile__skeleton" />}
        <img
          src={post.image}
          alt={`Post by ${post.username}`}
          className={`ig-tile__img${loaded ? " ig-tile__img--loaded" : ""}`}
          onLoad={() => setLoaded(true)}
        />
      </div>

      <div className="ig-tile__overlay">
        <div className="ig-tile__overlay-inner">
          <div className="ig-tile__username">{post.username}</div>
          <div className="ig-tile__meta">
            <span className="ig-tile__likes">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              {post.likes}
            </span>
            <span className="ig-tile__open-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div className="ig-tile__url">{post.url.replace("https://", "")}</div>
    </a>
  );
}

export default function InstagramFeed() {
  
  const [POSTS, setPOSTS] = useState([]);

  useEffect(() => {

    fetch(`https://api.negativbrand.com/en/api/instagram/10`)
        .then(response => response.json())
        .then(data => {
            setPOSTS(data);
        })
        .catch(error => {
            console.error(error);
        });

    }, []);

  return (
    <section className="ig-feed">

      <div className="ig-feed__grid">
        {POSTS.map((post, i) => (
          <InstagramTile key={post.id} post={post} index={i} />
        ))}
      </div>
    </section>
  );
}